export default {"src":"/_next/static/media/check.6898bf7c.svg","height":29,"width":29};